import { render } from "./Journeys.vue?vue&type=template&id=6d7324a9"
import script from "./Journeys.vue?vue&type=script&lang=js"
export * from "./Journeys.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__